// Which value the "Send to CapLegal with delay" checkbox opens with.
//
// The flag decides which CRM view the timelog lands in for the hourly Nav
// outbound: ticked waits 5 hours (9 on the firm's own matter) after the last
// edit, unticked goes on the next run, within the hour. A new log opens ticked.
//
// Outlook sync records are created by outlook_calendar_sync_crm.py, which never
// sets Send_to_CL_with_delay, so CRM stores false on every one of them. Since
// 0576059 (2026-07-08) the form mirrored the stored value, so converting an
// Outlook entry always opened unticked and the converted log reached CapLegal
// within the hour, with no grace period to edit or delete it. Converting creates
// a NEW timelog, so it gets the same default as any other new log. The employee
// can still untick it.
export function initialSendToCapLegal(initialData) {
  if (!initialData) return true;
  if (initialData.outlookSync) return true;
  return !!initialData.sendToCapLegal;
}
